import script from "./SpeakingMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakingMedia.vue?vue&type=script&setup=true&lang=js"

import "./SpeakingMedia.vue?vue&type=style&index=0&id=14598305&lang=scss"

const __exports__ = script;

export default __exports__